import {createSelector} from 'reselect';

import {getFilteredFeatures} from '@mapsight/core/lib/feature-selections/selectors';
import {findFeatureInFeatureSourcesById} from '@mapsight/core/lib/feature-sources/selectors';
import {FEATURE_SELECTION_PRESELECT, FEATURE_SELECTION_SELECT} from '@mapsight/ui/src/js/config/feature/selections';
import {FEATURE_SELECTIONS, FEATURE_SOURCES} from '@mapsight/ui/src/js/config/constants/controllers';
import {VIEW_DESKTOP, VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';


export const FEATURE_SELECTION_LAST_ON_TOUR = 'lastOnTour';

export const lastOnTourSelectionIdSelector = createSelector(
	state => state[FEATURE_SELECTIONS][FEATURE_SELECTION_LAST_ON_TOUR],
	selection => selection?.features && selection.features[0]
);

export const isViewWithMapWidget = (view) => (view === VIEW_DESKTOP || view === VIEW_MOBILE);

export const preselectFeatureSelector = createSelector(
	state => state[FEATURE_SELECTIONS][FEATURE_SELECTION_PRESELECT],
	state => state[FEATURE_SOURCES],
	/**
	 * @returns {null | import('../../stade/types').Feature}
	 */
	(featureSelection, featureSources) => {
		const features = getFilteredFeatures(featureSelection);
		const featureId = features && features[0];
		if (featureId) {
			return findFeatureInFeatureSourcesById(featureSources, featureId) || null;
		}
		return null;
	},
);

export const detailsFeatureSelector = createSelector(
	state => state[FEATURE_SELECTIONS][FEATURE_SELECTION_SELECT],
	state => state[FEATURE_SOURCES],
	/**
	 * @returns {null | import('../../stade/types').Feature}
	 */
	(featureSelection, featureSources) => {
		const features = getFilteredFeatures(featureSelection);
		const featureId = features && features[0];
		if (featureId) {
			return findFeatureInFeatureSourcesById(featureSources, featureId) || null;
		}
		return null;
	},
);

export const detailsSelector = createSelector(
	detailsFeatureSelector,
	(feature) => feature !== null,
);

/**
 * @param {*} sources
 * @param {string} featureId
 * @returns {null | string}
 */
export function findFeatureSourceIdForFeatureId(sources, featureId) {
	const res = Object.entries(sources)
		.find(([_, src]) => src.ids && src.ids.includes(featureId));
	return res !== undefined ? res[0] : null;
}

export const featureSelectionSelector = state => state[FEATURE_SELECTIONS][FEATURE_SELECTION_SELECT];

// export const createSelectionIndicesSelector = source => createSelector(
// 	state => state[FEATURE_SELECTIONS],
// 	(selections) => {
// 		const result = {
// 			[FEATURE_SELECTION_HIGHLIGHT]: { idx: -1},
// 			[FEATURE_SELECTION_PRESELECT]: { idx: -1},
// 			[FEATURE_SELECTION_SELECT]: { idx: -1}
// 		};
//
// 		if(!source || !source.ids) {
// 			return result;
// 		}
//
// 		const highlight = selections[FEATURE_SELECTION_HIGHLIGHT].features;
// 		const preselect = selections[FEATURE_SELECTION_PRESELECT].features;
// 		const select = selections[FEATURE_SELECTION_SELECT].features;
//
// 		if (highlight?.length) {
// 			result[FEATURE_SELECTION_HIGHLIGHT] = {
// 				idx: source.ids.indexOf(highlight[0]),
// 				length: source.ids.length
// 			};
// 		}
//
// 		if (preselect && highlight && preselect[0] === highlight[0]) {
// 			result[FEATURE_SELECTION_PRESELECT] = result[FEATURE_SELECTION_HIGHLIGHT];
// 		} else if (preselect?.length) {
// 			result[FEATURE_SELECTION_PRESELECT] = {
// 				idx: source.ids.indexOf(preselect[0]),
// 				length: source.ids.length
// 			};
// 		}
//
// 		if (select && preselect && select[0] === preselect[0]) {
// 			result[FEATURE_SELECTION_SELECT] = result[FEATURE_SELECTION_PRESELECT];
// 		} else if (select?.length) {
// 			result[FEATURE_SELECTION_SELECT] = {
// 				idx: source.ids.indexOf(select[0]),
// 				length: source.ids.length
// 			};
// 		}
//
// 		return result;
// 	}
// );


export const createPreselectionSelectionIndicesSelector = source => createSelector(
	state => state[FEATURE_SELECTIONS],
	(selections) => {
		const result = {
			[FEATURE_SELECTION_PRESELECT]: { idx: -1}
		};

		if(!source || !source.ids) {
			return result;
		}

		const preselect = selections[FEATURE_SELECTION_PRESELECT].features;

		if (preselect?.length) {
			result[FEATURE_SELECTION_PRESELECT] = {
				idx: source.ids.indexOf(preselect[0]),
				length: source.ids.length
			};
		}

		return result;
	}
);
